import React, { useEffect } from 'react'
import { Tabs } from 'antd';
import ViewsSummary from './ViewsSummary';
import ViewsDetail from './ViewsDetail';
import ViewsPerUserAndLesson from './ViewsPerUserAndLesson';
import { useQuery } from '@tanstack/react-query';
import { getUsers } from '../../server-functions/users';

function Views() {
    const [activeTab, setActiveTab] = React.useState('detail');

    useEffect(() => {
        document.title = 'דוחו"ת צפייה';
    }, []);

    const { data: users, status: usersStatus } = useQuery(
        {
            queryKey: ['all-users-for-views-report'],
            queryFn: getUsers,

        }
    );

    const tabItems = [
        {
            key: 'detail',
            label: <span style={{ padding: '0 12px' }}>פירוט כל הצפיות</span>,
            children: <ViewsDetail />,
        },
        {
            key: 'perUserLesson',
            label: <span style={{ padding: '0 12px' }}>דו"ח משתמש - שיעור</span>,
            children: <ViewsPerUserAndLesson users={users} usersStatus={usersStatus} />,
        },
        {
            key: 'summary',
            label: <span style={{ padding: '0 12px' }}>דו"ח כללי לפי משתמש</span>,
            children: <ViewsSummary />,
        },
    ];

    return (
        <div style={{ padding: '0 16px' }}>
            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                style={{ direction: 'rtl' }}
                tabBarGutter={0}
            />
        </div>
    );
}

export default Views;
